import { UserProfileService } from '@/app/services/user-profile'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { IProfile } from '@/types/profile'
import { useQuery, UseQueryOptions } from 'react-query'

export function useUserProfile(
  options?: Omit<
    UseQueryOptions<IApiIndividualResponse<IProfile>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<IApiIndividualResponse<IProfile>, ErrorResponse>(
    [UserProfileService.GET_PATH],
    () => UserProfileService.getProfile(),
    options
  )
}
